import React, { useState } from "react";
import cx from "classnames";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import styles from "./MyAccount.module.scss";
import { useCurrentPatient } from "./hooks/useCurrentPatient";
import {
  communicationPreferences,
  portalHome,
  rootLoginSwitch,
} from "features/routing/paths";
import chevronUpIcon from "images/arrow-up-new.png";
import chevronDownIcon from "images/arrow-down-new.svg";
import myAccountIcon from "images/my-account.svg";

const ACCOUNT_CHECK_INTERVAL_MS = 15_000;

export const MyAccount: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  const { currentPatient, logout } = useCurrentPatient();
  const { instance } = useMsal();

  React.useEffect(() => {
    if (
      currentPatient?.ciamSignedIn !== true ||
      currentPatient?.supportAccessSession === true
    ) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      if (instance.getActiveAccount()) return;

      const [firstAccount] = instance.getAllAccounts();
      if (firstAccount) {
        instance.setActiveAccount(firstAccount);
        return;
      }

      instance.logoutRedirect();
    }, ACCOUNT_CHECK_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, [currentPatient?.ciamSignedIn, currentPatient?.supportAccessSession, instance]);

  const toggle = () => {
    if (isOpen === false) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  return (
    <>
      <button onClick={toggle} className={styles.myAccountButton}>
        <img src={myAccountIcon} alt="my account icon" /> My Account{" "}
        {isOpen ? (
          <img src={chevronUpIcon} alt="chevron up icon" />
        ) : (
          <img src={chevronDownIcon} alt="chevron down icon" />
        )}
      </button>
      {isOpen && (
        <div className={styles.subButtons}>
          <Link to={portalHome}>
            <button className={styles.subButton}>Patient Portal</button>
          </Link>
          <Link to={rootLoginSwitch}>
            <button
              id="switchAccount"
              className={cx(styles.subButton, styles.middleButton)}
            >
              Select Patient
            </button>
          </Link>
          <Link
            to={communicationPreferences({
              patientId: currentPatient?.id as string,
            })}
          >
            <button className={cx(styles.subButton, styles.middleButton)}>
              Notification Settings
            </button>
          </Link>

          <button
            id="logout"
            onClick={logout}
            className={cx(styles.subButton, styles.bottomButton)}
          >
            Log Out
          </button>
        </div>
      )}
    </>
  );
};
